var hangarEnv = {
  development: {
    apiUrl: 'https://openair-dev.airtrfx.com/hangar-service/v2/',
    apiPath: '/airports/search',
    apiKey: 'BI6YTjWfcj8/IDOtpCjpLrJmLSKtCx2+AAQEpdggtgvNnrZhlDztX3/EwDfS16j4'
  },
  production: {
    apiUrl: 'https://openair-california.airtrfx.com/hangar-service/v2/',
    apiPath: '/airports/search',
    apiKey: 'HeQpRjsFI5xlAaSx2onkjc1HTK0ukqA1IrVvd5fvaMhNtzLTxInTpeYB1MK93pah'
  }
};
export { hangarEnv };